/* global axios */

import ApiClient from './ApiClient';

class WebhooksSendMessageLogs extends ApiClient {
  constructor() {
    super('webhooks_send_messages_logs', { accountScoped: true });
  }

  get({ page }) {
    const url = page ? `${this.url}?page=${page}` : this.url;
    return axios.get(url);
  }
}

export default new WebhooksSendMessageLogs();
